import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { FaCoins, FaUserCircle } from 'react-icons/fa';
import logo from '../images/logo.png';

const Header = () => {
  const [credits, setCredits] = useState(() => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return user?.credits ?? 0;
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const isLoggedIn = !!localStorage.getItem("token");

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

useEffect(() => {
 const updateCredits = (e) => {
  if (e?.detail?.credits !== undefined) {
    setCredits(e.detail.credits); // ✅ on prend UNIQUEMENT le nombre
  } else {
    const user = JSON.parse(localStorage.getItem("user"));
    setCredits(user?.credits ?? 0);
  }
};

  window.addEventListener("creditsUpdated", updateCredits);

  return () => {
    window.removeEventListener("creditsUpdated", updateCredits);
  };
}, []);



  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  // Fermer le dropdown si clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownRef]);

  return (
    <header style={styles.header}>
      <div style={styles.leftSection}>
        <Link to="/dashboard" style={styles.logoLink}>
          <img src={logo} alt="Vivacrea" style={styles.logo} />
        </Link>
      </div>

      <div style={styles.rightSection}>
        {isLoggedIn && (
          <div style={styles.item}>
            <FaCoins style={styles.headerIcon} aria-label="Crédits" />
            <span style={styles.creditsValue}>{credits}</span>
          </div>
        )}

        {isLoggedIn ? (
          <div style={styles.profileSection} ref={dropdownRef}>
            <FaUserCircle
              style={styles.profileIcon}
              aria-label="Profil"
              onClick={toggleDropdown}
            />

            {dropdownOpen && (
              <ul style={styles.dropdownMenu}>
                <li style={styles.dropdownItem}><Link to="/profile">Voir profil</Link></li>
                <li style={styles.dropdownItem}><Link to="/modifier-profil">Modifier le profil</Link></li>
                <li style={styles.dropdownItem} onClick={handleLogout}>Se déconnecter</li>
              </ul>
            )}
          </div>
        ) : (
          <div style={styles.authActions}>
            <Link to="/login" style={styles.authLink}>Connexion</Link>
            <Link to="/register" style={styles.authLinkPrimary}>Créer un compte</Link>
          </div>
        )}
      </div>
    </header>
  );
};

const styles = {
  header: {
    backgroundColor: '#ffffff',
    padding: '1rem 2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontFamily: 'Lexend, sans-serif',
  },
  logo: {
    height: '36px',
    width: 'auto',
    display: 'block',
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
  },
  item: {
    cursor: 'pointer',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  headerIcon: {
    width: '20px',
    height: '20px',
    color: 'var(--accent-primary)',
  },
  creditsValue: {
    color: 'var(--accent-fuchsia)',
    fontWeight: 600,
  },
  profileSection: {
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  profileIcon: {
    width: '24px',
    height: '24px',
    color: 'var(--accent-primary)',
    marginRight: '4px',
  },
  profileName: {
    fontWeight: 'bold',
    color: 'var(--accent-primary)',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    padding: '10px',
    listStyle: 'none',
    margin: 0,
    zIndex: 1000,
    width: '150px',
    borderRadius: '6px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  },
  dropdownItem: {
    padding: '8px 10px',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  authActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  authLink: {
    color: 'var(--accent-primary)',
    fontWeight: 600,
    textDecoration: 'none',
  },
  authLinkPrimary: {
    backgroundColor: 'var(--accent-primary)',
    color: '#fff',
    textDecoration: 'none',
    padding: '0.6rem 0.9rem',
    borderRadius: '999px',
    fontWeight: 600,
  },
};

export default Header;
